import axios from "axios";
import React from "react";
import { Card, Table } from "react-bootstrap";
import swal from "sweetalert";

const Reviews = ({ reviews }) => {
  //   console.log(reviews);
  const token = JSON.parse(localStorage.getItem("user"));

  const reviewStatusHandler = (e, _id) => {
    const selectedStatus = e.target.value;
    const reviewDataForSubmit = { selectedStatus, _id };
    // console.log(reviewDataForSubmit);
    axios
      .post(
        "https://mysterious-sierra-48850.herokuapp.com/review-status-updater",
        reviewDataForSubmit,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + token.token,
          },
        }
      )
      .then((data) => {
        if (data.data.success) {
          swal("", `${data.data.message}`, "success");
        }
      })
      .catch((err) => {
        console.log(err.response);
        swal("", `something went wrong`, "error");
      });
  };

  return (
    <div>
      {(reviews.length === 0 && <h1>Loading...</h1>) || (
        <>
          <Card>
            <Card.Title className="text-center">
              Reviews: {reviews.length}
            </Card.Title>
            <Card.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Review</th>
                    <th>Star</th>
                    <th>CreatedAt</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {reviews.length &&
                    reviews.map((reviewD, i) => {
                      const {
                        _id,
                        name,
                        userName,
                        review,
                        star,
                        status,
                        createdAt,
                      } = reviewD;
                      return (
                        <tr key={_id}>
                          <td>{i + 1}</td>
                          <td>{name}</td>
                          <td>{userName}</td>
                          <td>{review}</td>
                          <td>{star}</td>
                          <td>{new Date(createdAt).toLocaleString()}</td>
                          <td>
                            <select
                              onChange={(e) => reviewStatusHandler(e, _id)}
                              name="cars"
                              id="cars"
                            >
                              {status === "pending" ? (
                                <>
                                  <option value={status}>{status}</option>
                                  <option value="approved">approve</option>
                                </>
                              ) : status === "approved" ? (
                                <>
                                  <option value={status}>{status}</option>
                                  <option value="pending">pending</option>
                                </>
                              ) : null}
                            </select>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </>
      )}
    </div>
  );
};

export default Reviews;
